import React, { FC } from "react";

import { useHeaderMenu } from "../../../../../hooks/use-header-menu";
import { getLocalizedPath } from "../../../../../utils/pages";
import { Clickable } from "../../../../buttons/button/clickable";
import { LogoutButton } from "../../../common/logout-button";
import { UserGreeting } from "../../../common/user-greeting";
import { PersonalAreaCard } from "./personal-area-card";

export interface PersonalAreaAuthenticatedProps {
  node_locale: string;
  isCorporate?: boolean;
}

export const PersonalAreaAuthenticated: FC<PersonalAreaAuthenticatedProps> = ({
  node_locale,
  isCorporate = false,
}) => {
  const { labels } = useHeaderMenu();
  const profileUrl = getLocalizedPath("/personal-area/profile", node_locale);
  const calendarUrl = getLocalizedPath("/personal-area/calendar", node_locale);

  return (
    <div className="grid grid-cols-6 gap-8">
      <div className="flex flex-col gap-2 xl:gap-4 col-span-6 xl:col-span-2">
        <h3 className="text-2xl text-primary">
          {labels["header-menu-personal-area-authenticated-title"]}
        </h3>
        <UserGreeting />
        <p className="font-light flex-1">
          {labels["header-menu-personal-area-authenticated-body"]}
        </p>
        <LogoutButton />
      </div>
      <div className="hidden lg:block col-span-3 xl:col-span-2">
        {!isCorporate && (
          <PersonalAreaCard
            icon="profile" //TODO profile-edit is the right one but it mysteriously vanish one deployed on netlify
            title={labels["header-menu-personal-area-profile-card-title"]}
            body={labels["header-menu-personal-area-profile-card-body"]}
            cta={
              <a href={profileUrl}>
                <Clickable size="sm" variant="primary">
                  {labels["header-menu-personal-area-profile-card-cta"]}
                </Clickable>
              </a>
            }
          />
        )}
      </div>
      <div className="hidden lg:block col-span-3 xl:col-span-2">
        <PersonalAreaCard
          icon="calendar-check"
          title={labels["header-menu-personal-area-agenda-card-title"]}
          body={labels["header-menu-personal-area-agenda-card-body"]}
          cta={
            <a href={calendarUrl}>
              <Clickable size="sm" variant="primary">
                {labels["header-menu-personal-area-agenda-card-cta"]}
              </Clickable>
            </a>
          }
        />
      </div>
    </div>
  );
};
